/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MailIcon16Light } from './MailIcon16Light';
import { MailIcon16Regular } from './MailIcon16Regular';
import { MailIcon16Solid } from './MailIcon16Solid';
import { MailIcon20Light } from './MailIcon20Light';
import { MailIcon20Regular } from './MailIcon20Regular';
import { MailIcon20Solid } from './MailIcon20Solid';
import { MailIcon24Regular } from './MailIcon24Regular';
import { MailIcon24Solid } from './MailIcon24Solid';
import { MailIcon32Regular } from './MailIcon32Regular';
import { MailIcon64Regular } from './MailIcon64Regular';
var sizes = {
    16: {
        light: MailIcon16Light,
        regular: MailIcon16Regular,
        solid: MailIcon16Solid,
    },
    20: {
        light: MailIcon20Light,
        regular: MailIcon20Regular,
        solid: MailIcon20Solid,
    },
    24: {
        regular: MailIcon24Regular,
        solid: MailIcon24Solid,
    },
    32: {
        regular: MailIcon32Regular,
    },
    64: {
        regular: MailIcon64Regular,
    },
};
export var MailIcon = forwardRef('MailIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
